import { ANIMATION_NEW_ID } from 'constants/ui';

class UiManager {
  public onDragStart() {
    if (this.animationNew) this.animationNew.style.display = 'none';
  }
  public onDragEnd() {
    if (this.animationNew) this.animationNew.style.display = 'initial';
  }

  private get animationNew() {
    return document.getElementById(ANIMATION_NEW_ID);
  }
}

export default new UiManager();
